"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ItemPipes = require("./ItemPipes");
var _models = require("../../models");
var _HotSpotBox = _interopRequireDefault(require("../Models/HotSpotBox"));
var _Device = _interopRequireDefault(require("../Models/Device"));
var _constants = require("../../../utils/constants");
var _Types = require("../../../Types");
var _MainPipe = require("./MainPipe");
var _functions = require("../../../utils/functions");
var _WallModel = require("../Models/WallModel");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  sensorTypes,
  SectionTypes,
  LoopType,
  ComponentTypes,
  modelsWithVersion
} = _paulCorePackage.constants;
const Item = exports.Item = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    equipmentId,
    connectWithNext,
    position,
    isLastGroup,
    connectWithNextEquipment,
    isDisabled
  } = _ref;
  const type = ComponentTypes.HtgPipe;
  const showBox = false;
  return /*#__PURE__*/_react.default.createElement("group", {
    position: position
  }, /*#__PURE__*/_react.default.createElement("group", {
    position: [connectWithNextEquipment ? -_constants.spaseBetweenPipesByColInEquipmentItem : 0, 0, 0]
  }, /*#__PURE__*/_react.default.createElement(_ItemPipes.ItemPipes, {
    connectWithNext: connectWithNext,
    isDisabled: isDisabled
  })), connectWithNextEquipment && /*#__PURE__*/_react.default.createElement(_MainPipe.MainPipe, {
    connectWithNext: true
  }), /*#__PURE__*/_react.default.createElement("group", {
    position: [connectWithNextEquipment ? -_constants.spaseBetweenPipesByColInEquipmentItem : 0, 0, 0]
  }, /*#__PURE__*/_react.default.createElement("group", {
    position: [-10, 0, -5.6]
  }, /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 53, 0],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingFlow
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: equipmentId,
    thingLoopType: LoopType.none,
    thingSectionType: SectionTypes.flow,
    panelPosition: [1, 0, -8]
    // requiredType={sensorTypes.energyValve}
    // anywayShow
    ,
    modelProps: {
      [sensorTypes.energyValve]: {
        activeCable: _constants.activeCableDirection.front,
        deviceRotate: [Math.PI / 2, 0, Math.PI / 2],
        scale: [1, -1, 1]
      },
      [sensorTypes.temperatureSensor]: {
        [modelsWithVersion.paulTemperature_v1]: {
          activeCable: _constants.activeCableDirection.horizontal,
          position: [0, 0, -5.6]
        }
      }
    },
    panelProps: {
      secondPosition: _constants.panelPosition.left
    }
  }))), /*#__PURE__*/_react.default.createElement("group", {
    position: [-10, 0, -11.2]
  }, /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 43, 0],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingReturn
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: equipmentId,
    thingLoopType: LoopType.none,
    thingSectionType: SectionTypes.return,
    panelPosition: [1, 0, -8]
    // requiredType={sensorTypes.energyValve}
    // anywayShow
    ,
    modelProps: {
      [sensorTypes.energyValve]: {
        activeCable: _constants.activeCableDirection.front,
        deviceRotate: [Math.PI / 2, 0, Math.PI / 2],
        scale: [1, -1, 1]
      },
      [sensorTypes.temperatureSensor]: {
        [modelsWithVersion.paulTemperature_v1]: {
          activeCable: _constants.activeCableDirection.horizontal
        }
      }
    },
    panelProps: {
      secondPosition: _constants.panelPosition.left
    }
  }))), /*#__PURE__*/_react.default.createElement("group", {
    position: [-10, 70, -8.4]
  }, /*#__PURE__*/_react.default.createElement(_WallModel.WallModel, {
    position: [-10.6, 0, 0],
    args: [25, 0.2, 10],
    color: (0, _functions.checkDisabledColor)(isDisabled, _constants.wallColor)
  }), /*#__PURE__*/_react.default.createElement(_WallModel.WallModel, {
    position: [-23, 10, 0],
    rotation: [0, 0, Math.PI / 2],
    args: [20, 0.2, 10],
    visible: isLastGroup,
    color: (0, _functions.checkDisabledColor)(isDisabled, _constants.wallColor)
  }), /*#__PURE__*/_react.default.createElement(_models.RadiatorModel, {
    position: [-19, 10, 0],
    rotation: [0, Math.PI / 2, 0]
  }))));
});
Item.propTypes = {
  equipmentId: _paulCorePackage.customPropTypes.equipmentIdType,
  connectWithNext: _propTypes.default.bool,
  connectWithNextEquipment: _propTypes.default.bool,
  position: _Types.VectorType,
  isLastGroup: _propTypes.default.bool,
  isDisabled: _propTypes.default.bool
};
Item.defaultProps = {
  connectWithNext: false,
  connectWithNextEquipment: false,
  position: [0, 0, 0],
  isLastGroup: false,
  isDisabled: false
};